{
  "repositoryName": "very-f-ing-real",
  "routes": [
    {
      "type": "page",
      "uid": "index",
      "path": "/"
    },
    {
      "type": "page",
      "path": "/:uid"
    }
  ]
}